import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/menu', label: 'Menu' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/next-event', label: 'Next Event' },
    { path: '/reserve', label: 'Reserve' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-cream shadow-luxury sticky top-0 z-50 border-b-2 border-gold">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="nav-logo">
            <img 
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_client-web-setup/artifacts/u0r810nb_6587f527-a426-4957-b4cf-1f060757bebd.jpeg" 
              alt="Mama-Mam's Kitchen" 
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex space-x-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-2.5 lg:px-4 py-2 rounded-full font-medium transition-all whitespace-nowrap text-sm lg:text-base ${
                  isActive(link.path)
                    ? 'bg-gold text-white shadow-md'
                    : 'text-brown hover:bg-gold-light hover:text-brown'
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-brown hover:text-gold"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden pb-4 space-y-2" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-5 py-3 rounded-full font-medium transition-all ${
                  isActive(link.path)
                    ? 'bg-gold text-white'
                    : 'text-brown hover:bg-gold-light hover:text-brown'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
